import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core'
import { FormControl } from '@angular/forms'
import { AssetIdValidator } from '@helios/validators'
import { map, tap } from 'rxjs/operators'

export interface SecurityFilter {
  security: string
  currentlyHeld: boolean
  valid: boolean
}

@Component({
  selector: 'hs-security-filter',
  template: `
    <nf-form-control
      label="Asset Id"
      compact="compact"
      hint="One security identifier. e.g. CCYUSD"
    >
      <div class="input-group">
        <input type="text" [formControl]="securityForm" placeholder="CCYUSD" />
        <div class="input-group-append">
          <div class="input-group-text">
            <nf-checkbox
              label="Currently Held"
              [formControl]="currentlyHeldForm"
            ></nf-checkbox>
          </div>
        </div>
      </div>
    </nf-form-control>
  `,
  styleUrls: ['./security-filter.component.scss'],
})
export class SecurityFilterComponent implements OnInit {
  @Output() securityFilterForm = new EventEmitter<SecurityFilter>()
  @Input() security?: string
  @Input() currentlyHeld?: boolean

  securityForm: FormControl = new FormControl('', AssetIdValidator)
  currentlyHeldForm: FormControl = new FormControl(true)

  private securityFilter: SecurityFilter = {
    security: '',
    currentlyHeld: true,
    valid: true,
  }

  ngOnInit(): void {
    this.securityFilter = {
      security: this.security ?? '',
      currentlyHeld: this.currentlyHeld ?? true,
      valid: true,
    }
    this.securityForm.reset(this.securityFilter.security)
    this.currentlyHeldForm.reset(this.securityFilter.currentlyHeld)
    this.securityForm.valueChanges
      .pipe(
        map(value => value.trim()),
        tap(value => {
          this.securityFilter.security = value
          this.securityFilter.valid = this.securityForm.valid
          this.securityFilterForm.emit(this.securityFilter)
        }),
      )
      .subscribe()
    this.currentlyHeldForm.valueChanges
      .pipe(
        tap(value => {
          this.securityFilter.currentlyHeld = value
          this.securityFilterForm.emit(this.securityFilter)
        }),
      )
      .subscribe()
  }
}
